// assets/share.js
if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();
        // ここでは何もしない（早期呼び出しで elements 未定義を避ける）
      }

      connectedCallback() {
        // ここで初期化（複数回呼ばれても安全）
        this._initOnce?.() || (this._initOnce = true, this._init());
      }

      _init() {
        // 要素の再取得（常に DOM から拾う）
        this.elements = {
          shareButton:   this.querySelector('button'),
          shareSummary:  this.querySelector('summary'),
          closeButton:   this.querySelector('.share-button__close'),
          successMessage:this.querySelector('[id^="ShareMessage"]'),
          urlInput:      this.querySelector('input'),
        };

        // URL 初期値
        const initialUrl =
          (this.elements.urlInput && this.elements.urlInput.value) ||
          document.location.href;
        this.urlToShare = initialUrl;

        // DetailsDisclosure を使う UI/DOM がない場合に備えて存在チェック
        const hasDetailsUI = !!this.mainDetailsToggle;

        if (navigator.share && this.elements.shareButton) {
          if (hasDetailsUI) this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener('click', () => {
            navigator.share({ url: this.urlToShare, title: document.title });
          });
        } else if (hasDetailsUI) {
          // Dawn の details ベースのUIがある時だけ紐付け
          this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
          const copyBtn = this.mainDetailsToggle.querySelector('.share-button__copy');
          if (copyBtn) copyBtn.addEventListener('click', this.copyToClipboard.bind(this));
          const closeBtn = this.mainDetailsToggle.querySelector('.share-button__close');
          if (closeBtn) closeBtn.addEventListener('click', this.close.bind(this));
        }

        // 初期URLを反映
        this.updateUrl(initialUrl);
      }

      toggleDetails() {
        if (!this.mainDetailsToggle?.open) {
          this.elements?.successMessage?.classList.add('hidden');
          if (this.elements?.successMessage) this.elements.successMessage.textContent = '';
          this.elements?.closeButton?.classList.add('hidden');
          this.elements?.shareSummary?.focus?.();
        }
      }

      copyToClipboard() {
        const text = this.elements?.urlInput?.value || this.urlToShare || document.location.href;
        navigator.clipboard.writeText(text).then(() => {
          if (this.elements?.successMessage) {
            this.elements.successMessage.classList.remove('hidden');
            this.elements.successMessage.textContent = window.accessibilityStrings?.shareSuccess || 'Copied';
          }
          this.elements?.closeButton?.classList.remove('hidden');
          this.elements?.closeButton?.focus?.();
        });
      }

      updateUrl(url) {
        // ★ ここを防御的に：elements 未初期化でも落ちない
        if (!this.elements) {
          // 遅延初期化（最小限）
          this.elements = { urlInput: this.querySelector('input') };
        }
        this.urlToShare = url || this.urlToShare || document.location.href;

        const input = this.elements.urlInput || this.querySelector('input');
        if (input) input.value = this.urlToShare;

        // もしリンク(a)を持っている実装なら、ここで href 再計算しても良い
        const xLink = this.querySelector('[data-share-x]');
        const fbLink = this.querySelector('[data-share-facebook]');
        if (xLink || fbLink) {
          const u = encodeURIComponent(this.urlToShare);
          const t = encodeURIComponent(document.title || '');
          if (xLink) xLink.href = `https://x.com/intent/post?url=${u}&text=${t}`;
          if (fbLink) fbLink.href = `https://www.facebook.com/sharer/sharer.php?u=${u}`;
        }
      }
    }
  );
}
